import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import ContentBox from "../../ContentBox";
import EmojiEventsIcon from "@material-ui/icons/EmojiEventsOutlined";
import { CompetitionResource } from "@ploy-lib/rest-resources";
import { DployAutocomplete } from "@ploy-ui/form-fields";
import { FormattedNumber, FormattedMessage, defineMessages } from "react-intl";
import { Grid, Box, Tooltip } from "@material-ui/core";
import { usePrefetchResources } from "../usePrefetchResources";
import { CompetitionResult } from "./CompetitionResult";
export const columnTitleMessages = defineMessages({
    position: {
        id: "dploy.competitions.position.header",
        defaultMessage: "Position"
    },
    salespersonName: {
        id: "dploy.competitions.salesPerson.header",
        defaultMessage: "Name"
    },
    score: {
        id: "dploy.competitions.score.header",
        defaultMessage: "Points"
    },
    contracts: {
        id: "dploy.competitions.contracts.header",
        defaultMessage: "Count"
    },
    loanAmount: {
        id: "dploy.competitions.loanAmount.header",
        defaultMessage: "Volume"
    },
    budgetPercentage: {
        id: "dploy.competitions.budgetPercentage.header",
        defaultMessage: "Budget"
    },
    vendor: {
        id: "dploy.competitions.vendor.header",
        defaultMessage: "Vendor"
    }
});
export const allColumns = [
    {
        defaultSort: "asc",
        field: "position",
        type: "numeric",
        width: 20,
        headerStyle: {
            padding: 0,
            paddingLeft: 10
        },
        cellStyle: {
            paddingLeft: 0,
            paddingRight: 0,
            textAlign: "center"
        }
    },
    {
        field: "salespersonName"
    },
    {
        field: "budgetPercentage",
        type: "numeric",
        render: row => row.budgetPercentage && (_jsx(FormattedNumber, { value: row.budgetPercentage / 100, 
            // eslint-disable-next-line react/style-prop-object
            style: "percent", minimumFractionDigits: 2 })),
        headerStyle: {
            justifyItems: "center"
        },
        cellStyle: {
            textAlign: "center"
        }
    },
    {
        field: "score",
        type: "numeric",
        cellStyle: {
            textAlign: "center"
        },
        headerStyle: {
            justifyItems: "center"
        }
    },
    {
        field: "contracts",
        type: "numeric",
        cellStyle: {
            textAlign: "center"
        }
    },
    {
        field: "loanAmount",
        type: "numeric",
        render: row => row.loanAmount && (_jsx(FormattedNumber, { value: row.loanAmount, format: "currency" })),
        cellStyle: {
            textAlign: "center"
        },
        headerStyle: {
            justifyItems: "center"
        }
    },
    {
        field: "vendor",
        render: row => (_jsx(Tooltip, { title: row.vendor, enterDelay: 500, leaveDelay: 200, children: _jsx(Box, { whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", children: row.vendor }) })),
        cellStyle: {
            maxWidth: 1
        }
    }
];
const resources = (props) => [[CompetitionResource.list(), { visible: true }]];
const Competitions = props => {
    const { boxProps, visibleColumns, scrollable = false, placeholder } = props;
    const [competitions = []] = usePrefetchResources(Competitions, props, placeholder);
    const [first] = competitions;
    const [selected = first, setSelected] = useState(first);
    const competitionSelector = (_jsxs(Grid, { container: true, justifyContent: "space-between", alignItems: "center", spacing: 1, children: [_jsx(Grid, { item: true, xs: 12, sm: 8, md: 6, children: _jsx(DployAutocomplete, { items: competitions, value: selected, onChange: (e, item) => setSelected(item ?? first), getItemLabel: item => item.name, searchable: false, disableClearable: true, AutocompleteProps: {
                        getOptionSelected: (option, value) => option.pk() === value.pk()
                    } }, "competition-selector") }), _jsx(Grid, { item: true, children: selected && (_jsx(Box, { p: 1, children: _jsx(FormattedMessage, { id: "dploy.competition.info", defaultMessage: "Valid from {validFrom, date, full} to {validTo, date, full}", values: {
                            validFrom: selected.starttime
                                ? new Date(selected.starttime)
                                : null,
                            validTo: selected.endtime ? new Date(selected.endtime) : null,
                            name: selected.name,
                            description: selected.description
                        } }) })) })] }));
    return (_jsx(ContentBox, { ...boxProps, header: _jsx(FormattedMessage, { id: "dploy.competitions.header", defaultMessage: "Competition" }), avatar: _jsx(EmojiEventsIcon, {}), fallbackContent: _jsx(Box, { display: "flex", flexDirection: "column", overflow: "hidden", children: competitionSelector }), children: _jsxs(Box, { display: "flex", flexDirection: "column", overflow: "hidden", children: [competitionSelector, (selected || placeholder) && (_jsx(CompetitionResult, { visibleColumns: visibleColumns, competitionId: selected?.id, placeholder: placeholder, scrollable: typeof scrollable === "string" ? scrollable === "1" : scrollable }))] }) }));
};
Competitions.getPrefetch = resources;
Competitions.getVisibilityFetch = resources;
Competitions.getVisibility = (props, [competitions]) => competitions?.length > 0;
Competitions.minHeight = 550;
Competitions.displayName = "DployDashboardCompetitions";
export default Competitions;
//# sourceMappingURL=Competitions.js.map